import React from 'react';
import { Link } from 'react-router-dom';
import './Pricing.css';

const Pricing = () => {
  const packages = [
    {
      name: 'Starter',
      tagline: 'Sichtbarkeit aufbauen',
      monthly: '199',
      setup: '500',
      description: 'Ideal für den professionellen Einstieg auf Social Media',
      features: [
        'Strukturierte Content-Planung',
        'Konsistente Markenpräsenz',
        '8 hochwertige Posts pro Monat',
        '4 Reels pro Monat',
        'Fokus auf einer Hauptplattform',
        'Community Management',
        'Monatliches Reporting'
      ],
      result: 'Ein klarer, professioneller Auftritt, der Vertrauen aufbaut und deine Marke sichtbar positioniert.',
      popular: false
    },
    {
      name: 'Growth',
      tagline: 'Reichweite erweitern',
      monthly: '249',
      setup: '1.000',
      description: 'Für ambitionierte Marken, die ihre Reichweite gezielt ausbauen wollen',
      features: [
        '12-16 Posts pro Monat',
        '6-8 strategisch optimierte Reels',
        'Präsenz auf 2 relevanten Plattformen',
        'Individuelle Content-Strategie',
        'Kontinuierliches Community Management',
        'Hashtag- und Keyword-Optimierung',
        'Erweiterte Analytics'
      ],
      result: 'Wachsende Reichweite und stärkere Wahrnehmung bei deiner Zielgruppe.',
      popular: false
    },
    {
      name: 'Pro',
      tagline: 'Kunden gewinnen',
      monthly: '299',
      setup: '2.000',
      description: 'Performance-fokussiert mit ersten Paid-Ads-Kampagnen',
      features: [
        '16+ performance-optimierte Inhalte',
        'Einstieg in gezielte Werbeanzeigen',
        'Regelmäßige Analyse und Optimierung',
        'Umfassendes Channel-Management',
        'Lead-Generierung-Strategien',
        'A/B-Testing',
        'Persönliche Beratung'
      ],
      result: 'Konstante Kundenanfragen und eine verlässliche Grundlage für planbares Wachstum.',
      popular: true
    },
    {
      name: 'Business',
      tagline: 'Wachstum strukturieren',
      monthly: '349',
      setup: '3.000',
      description: 'Für etablierte Unternehmen mit Wachstumsambitionen',
      features: [
        'Kontinuierliche Content-Produktion',
        'Präsenz auf allen relevanten Kanälen',
        'Plattformübergreifende Strategie',
        'Laufende Anzeigen-Optimierung',
        'Marketing-Prozess Feinjustierung',
        'Funnel-Aufbau & -Optimierung',
        'Bi-weekly Strategy Calls'
      ],
      result: 'Ein strukturiertes System, das nachhaltiges und skalierbares Wachstum ermöglicht.',
      popular: false
    },
    {
      name: 'Premium',
      tagline: 'Markenpräsenz ausbauen',
      monthly: '399',
      setup: '4.000',
      description: 'Das Komplettpaket für maximale Markenwirkung',
      features: [
        'Hochwertige Content-Produktion auf Profi-Niveau',
        'Ganzheitliche Marketing-Strategie',
        'Organische & Paid-Ads-Skalierung',
        'Datenbasierte Skalierung',
        'Komplette Customer Journey Optimierung',
        'Individuelles Personal Branding',
        'VIP-Support & Priority Service'
      ],
      result: 'Eine starke Marktpräsenz und eine klar positionierte Marke, die nachhaltig Wachstum generiert.',
      popular: false
    }
  ];

  return (
    <div className="pricing-page">
      {/* Hero */}
      <section className="pricing-hero">
        <div className="pricing-hero-bg"></div>
        <div className="pricing-hero-content">
          <span className="section-label">Preise & Pakete</span>
          <h1 className="pricing-hero-title">
            Transparente Preise –<br />
            <span className="gold">maßgeschneidertes Wachstum</span>
          </h1>
          <p className="pricing-hero-subtitle">
            Für jeden Anspruch das passende Paket. Vom strukturierten Einstieg bis zur 
            ganzheitlichen Premium-Betreuung. Ich finde die richtige Lösung für dein Business.
          </p>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="pricing-grid-section">
        <div className="section-container">
          <div className="pricing-grid">
            {packages.map((pkg, index) => (
              <div 
                key={index} 
                className={`pricing-card ${pkg.popular ? 'popular' : ''}`}
              >
                {pkg.popular && (
                  <div className="popular-badge">Beliebteste Wahl</div>
                )}
                
                <div className="pricing-header">
                  <h3 className="pricing-name">{pkg.name}</h3>
                  <p className="pricing-tagline">{pkg.tagline}</p>
                </div>

                <div className="pricing-amount">
                  <div className="amount-monthly">
                    <span className="amount-value">{pkg.monthly}€</span>
                    <span className="amount-label">/ Monat</span>
                  </div>
                  <div className="amount-setup">
                    + {pkg.setup}€ Setup
                  </div>
                </div>

                <p className="pricing-description">{pkg.description}</p>

                <ul className="pricing-features">
                  {pkg.features.map((feature, i) => (
                    <li key={i}>
                      <span className="feature-check">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>

                <div className="pricing-result">
                  <span className="result-label">Dein Ergebnis:</span>
                  <p>{pkg.result}</p>
                </div>

                <Link
                  to={`/kontakt?paket=${encodeURIComponent(pkg.name + ' Paket')}`}
                  className={`pricing-cta ${pkg.popular ? 'cta-primary' : 'cta-outline'}`}
                  data-testid={`pricing-cta-${pkg.name.toLowerCase()}`}
                >
                  {pkg.name} anfragen
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Custom Solution */}
      <section className="custom-section">
        <div className="section-container">
          <div className="custom-card">
            <div className="custom-content">
              <span className="section-label">Individuelle Lösung</span>
              <h2>Du brauchst etwas anderes?</h2>
              <p>
                Jedes Business ist einzigartig. Wenn du eine maßgeschneiderte Lösung 
                außerhalb der Standard-Pakete brauchst, lass uns sprechen. 
                Gemeinsam entwickeln wir das perfekte Setup für dein Business.
              </p>
              <Link to="/kontakt" className="btn-primary">
                Individuelles Angebot anfragen
                <span className="btn-arrow">→</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="section-container">
          <div className="section-header">
            <span className="section-label">FAQ</span>
            <h2 className="section-title">Häufige Fragen</h2>
          </div>

          <div className="faq-grid">
            <div className="faq-item">
              <h3>Welches Paket passt zu mir?</h3>
              <p>Das hängt von deinen Zielen, deinem aktuellen Stand und deinem Budget ab. Im kostenlosen Erstgespräch finden wir gemeinsam das passende Paket für dich.</p>
            </div>
            <div className="faq-item">
              <h3>Gibt es eine Mindestlaufzeit?</h3>
              <p>Für nachhaltige Ergebnisse empfehle ich eine Zusammenarbeit von mindestens 3 Monaten. Social Media Marketing braucht Zeit, um seine volle Wirkung zu entfalten.</p>
            </div>
            <div className="faq-item">
              <h3>Was ist im Setup enthalten?</h3>
              <p>Im Setup sind die strategische Vorbereitung, Profil-Optimierung, Content-Pillar-Definition, Branding-Setup und das initiale Onboarding enthalten.</p>
            </div>
            <div className="faq-item">
              <h3>Wie schnell sehe ich Ergebnisse?</h3>
              <p>Erste Veränderungen siehst du oft schon innerhalb der ersten 4-6 Wochen. Nachhaltiges Wachstum entsteht jedoch über einen Zeitraum von 3-6 Monaten.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="pricing-cta-section">
        <div className="section-container">
          <div className="pricing-cta-content">
            <h2>Bereit, dein Business auf das nächste Level zu heben?</h2>
            <p>Lass uns im kostenlosen Erstgespräch über deine Ziele sprechen.</p>
            <div className="cta-button-wrapper">
              <Link to="/buchen" className="btn-primary">
                Direkt Termin buchen
                <span className="btn-arrow">→</span>
              </Link>
              <Link to="/kontakt" className="btn-secondary">
                Kontaktformular
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
